import { QuestionBase } from '../question-base';

export class DocumentQuestion extends QuestionBase<string> {
  controlType = 'document';
}